<template>
    <div>
        <div class="video_list">
            <div class="video_box" @click="todetail(index)" v-for="(item,index) in storeList">
                <div class="videobox_left">
                    <img class="video_img" :src="item.thumb"/>
                    <div class="video_des">{{item.name}}</div>
                </div>
                <img class="video_to" src="/static/xiangyou.png"/>
            </div>
        </div>
    </div>
</template>

<script>
    import httper from '../../api/http';
    import axios from 'axios'

    export default {
        data() {
            return {
                storeList: [],//接口获取商品列表
                showTopTips: false, // 错误提示(手机号码格式错误),默认为false
                isPackage: false, // 用户是否选择套餐,默认为false
                chargeNum: '', // 所充值的号码,默认为空
                packageValue: '', // 套餐标识,默认为空
                isPhone: '', // 所充值的账号是否为手机,影响chargeNum的最大输入长度,brandChange()改变其值,默认为空
                brandIndex: '0', // 品牌指针,默认为空
                price: '', // 用户选择油卡充值所对应的应付金额,默认为空
                amount: 0, // 接口获取用户可用余额,默认为0
                canAmountPay: false, // 判断用户可用余额是否大于等于应付金额,默认为false
                isAmountPay: false, // 用户是否点击radio使用余额支付,默认为false
                buttonClicked: false // 防止支付重复点击,默认为false
            }
        },
        created() {
            this.request('getganggang')
            this.request('getUserInfo')
            console.log("this.$route.query.cate_id", this.$route.query.cate_id)
            if (this.$route.query.cate_id) {
                this.request("getstoreList", {
                    cate_id: this.$route.query.cate_id
                })
            }

        },
        mounted() {

        },
        methods: {
            // todetail(e) {
            //   this.$router.push({
            //     path: "/videoDetail",
            //     query: {
            //       videoDetailId: e
            //     }
            //   })
            // },
            todetail(e) {

                this.$router.push({
                    path: '/videoDetail',
                    query: {
                        // storeid: e,
                        // listDetail:this.list[e]
                        id: this.storeList[Number(e)].id
                    }
                })
            },
            // 调用接口封装
            request(type = '', requestData = {}) {
                let that = this
                switch (type) {
                    //刚进入页面获取的数据
                    case 'getganggang':
                        axios.get(process.env.API_HOST + '/product/get-online-by-api-tab', {
                            params: {
                                tab_id: 3
                            }
                        })
                            .then(function (res) {
                                if (res.data.code == 0) {
                                    console.log("res", res.data.data)
                                    let brandIndex
                                    let isPhone
                                    for (let i in res.data.data) {
                                        res.data.data[i].index = i
                                        res.data.data[i].brandChecked = false
                                        res.data.data[i].isPhone = false

                                        if (res.data.data[i].api_tab == 'iq_video' || res.data.data[i].api_tab == 'yk_video') {
                                            res.data.data[i].isPhone = true
                                        }

                                        for (let c in res.data.data[i].productItem) {
                                            res.data.data[i].productItem[c].packageChecked = false
                                            res.data.data[i].productItem[c].isSoldOut = false
                                            res.data.data[i].productItem[c].index = c
                                        }
                                    }
                                    res.data.data[0].brandChecked = true
                                    brandIndex = 0
                                    isPhone = res.data.data[0].isPhone
                                    that.list = res.data.data
                                    console.log("list", that.list)
                                    that.brandIndex = brandIndex
                                    that.isPhone = isPhone;
                                } else {
                                    // swal('res.data.message', 'success')
                                    this.$toast({
                                      message: res.data.message,
                                    })
                                }
                            })
                        break
                    //获取个人信息余额
                    case 'getUserInfo':
                        //获取个人信息余额
                        httper.get('/wechat/user/info', requestData, res => {
                            if (res.code === 0) {
                                var amount1 = res.data.account.amount.toFixed(2)
                                that.amount = amount1
                                console.log('amount1', amount1)
                            } else {
                                that.$toast({
                                    message: res.message || '系统异常',
                                })
                            }
                        }, true)
                        break
                    //获取商品列表
                    case 'getstoreList':
                        httper.get('product/get-online-by-cate', requestData, res => {
                            if (res.code === 0) {
                                console.log("商品列表", res)
                                this.storeList = res.data
                            } else {
                                this.$toast({
                                    message: res.message
                                })
                            }
                        })
                        break
                    //余额支付
                    case 'YeunifiedOrder':
                        httper.post('/payment/unified-order', requestData, res => {
                            if (res.code === 0) {
                                wx.navigateTo({
                                    url: '/pages/order/detail?id=' + res.data.order_no
                                })
                            } else {
                                that.$toast({
                                    message: res.data.message || '系统异常',
                                })
                            }
                        }, true)
                        break
                }
            },
        }
    }
</script>

<style>
    .video_list {
        margin: 20px;
    }

    .video_box {
        width: 95%;
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border: 1px solid #dedede;
        margin-bottom: 20px;
        /* background-image: url(../../../static/aiqiyibanner.png); */
    }

    .videobox_left {
        display: flex;
        align-items: center;
    }

    .video_img {
        width: 50px;
        height: 50px;
        border-radius: 25px;
        margin: 10px;
    }

    .video_des {
    }

    .video_to {
        width: 35px;
        height: 35px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/video/videoList.vue